module.exports = __webpack_public_path__ + "img/id2.01a58218.png";